import {Controller} from "@hotwired/stimulus";
import { callKarrotBridgeSafely } from "../../lib/karrot_bridge_utils";

export default class extends Controller {
    close(event) {
        const customUrl = event.target.dataset.customUrl

        if (customUrl) {
            const hideNavbar = window.controllersWithNavbar.some((controller) => customUrl.includes(controller))
            const url = customUrl.startsWith('http') ? customUrl : `${window.location.origin}${customUrl}`

            callKarrotBridgeSafely(
                (bridge) => bridge.pushRouter({
                    router: {
                        remote: url,
                        navbar: !hideNavbar
                    }
                }),
                { fallback: () => { window.location.href = url } }
            )
        } else {
            callKarrotBridgeSafely(
                (bridge) => bridge.closeRouter({}),
                { fallback: () => window.history.back() }
            )
        }
    }
}
